import React from 'react'
import PropTypes from 'prop-types'
import theme from '../../theme'
import SideBarItem from '../Sidebar/SidebarItem/SidebarItem'

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography'
import Aux from '../../hoc/Ax/Ax'

import {t} from 'i18next'

const styles = {
    button: {
        marginLeft: -15,
    },
    typo: {
        color: theme.typography.caption.color,
        fontSize: 16,
    },
}

/**
 * component for sidebar
 * @param classes
 * @param userEmail
 * @param changePassword
 * @returns {*}
 */
const personalInformation = ({ classes, userEmail, changePassword }) => (
    <Aux>
        <SideBarItem
            title={t('User.title_personalinformation_account')}
            subtitle={t('User.subtitle_personalinformation_account')}
            children={<Typography style={styles.typo}>{userEmail}</Typography>}/>
            <br></br>
            <br></br>
        <SideBarItem
            title={t('User.title_personalinformation_password')}
            subtitle={t('User.subtitle_personalinformation_password')}
            children={
            <Button 
             onClick={() => changePassword()} 
             variant={'outlined'}
             style={{...styles.button, color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop:20}}>
            {t('User.button_change')}
            </Button>
            }     
        />
    </Aux>
)

personalInformation.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    userEmail: PropTypes.string.isRequired,
    changePassword: PropTypes.func.isRequired,
}

export default personalInformation
